import React from 'react';
import useTranslation from '../../../Hooks/UseTranslation';

type Props = {
    isNotRead: boolean,
    icon: any,
    data: any,
    onClick: any,
    timeDifference: string
}

const DeleteProjectNotification = (props: Props) => {

    const { t } = useTranslation()

    return (
        <div
            className={`${props.isNotRead ? 'dropdownnotification' : ''} dropdown-item d-flex`}
            onClick={props.onClick}
        >
            <div className="notification-icon" style={{ padding: '10px' }}>
                {props.icon}
            </div>
            <div className="notification-details flex-grow-1">
                <p className="m-0 d-flex align-items-center">
                    <span>Proyecto <strong>{props.data.project_deleted}</strong></span>
                    {props.data.status === 'read' ? null : (
                        <span className="badge badge-pill badge-primary ml-1 mr-1">
                            {t('NOTIFICATIONS_DELETE_PROJECT:Pending')}
                        </span>
                    )}
                    <span className="flex-grow-1"></span>
                </p>
                <p className=" text-muted m-0">
                    <span className='notification-content'>
                        {t('NOTIFICATIONS_DELETE_PROJECT:TheOwnerHasDeletedTheProject')}
                    </span>
                </p>
            </div>
        </div>
    )
}

export default DeleteProjectNotification